import TR from 'utils/TR';
import Section from 'components/common/Section';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';
import { numberWithComma } from 'utils/number';

import 'chartjs-adapter-luxon';


import ExercisePatternChart from '../../../charts/ExercisePatternChart';

export default function ExercisePattern(props) {
  const {
    viewMode,
    stepData,
    caloryData,
    duration,
    ...rest
  } = props || {};

  const stepList = React.useMemo(() => {
    const {
      active_pattern_time_zone_list = []
    } = stepData || {};
    return active_pattern_time_zone_list;
  }, [stepData]);

  const caloryList = React.useMemo(() => {
    const {
      active_pattern_time_zone_list = []
    } = caloryData || {};
    return active_pattern_time_zone_list;
  }, [caloryData]);

  return (
    <Section
      {...ex('ExercisePattern', rest)}
      {...{
        caption: T('활동분석 (day)'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      <div>
        <ExercisePatternChart {...props} />
      </div>
      <table>
        <thead>
          <tr>
            <th>
              <div>
                {T('구분')}
              </div>
            </th>
            <th>
              <div>
                {T('새벽(0-6H)')}
              </div>
            </th>
            <th>
              <div>
                {T('오전(6-12H)')}
              </div>
            </th>
            <th>
              <div>
                {T('오후(12-18H)')}
              </div>
            </th>
            <th>
              <div>
                {T('저녁(18-24H)')}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                {viewMode === 'ReportExerciseSteps' && T('시간대별 평균 걸음수 (보)')}
                {viewMode === 'ReportExerciseCalories' && T('시간대별 평균 소모칼로리 (kcal)')}
              </div>
            </td>
            {viewMode === 'ReportExerciseSteps' && stepList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {(!data.avg_step_cnt ? '-' : numberWithComma(data.avg_step_cnt)).padStart(8, '⠀')}
                  </div>
                </td>
              );
            })}
            {viewMode === 'ReportExerciseCalories' && caloryList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {(!data.avg_cal_amt ? '-' : numberWithComma(data.avg_cal_amt)).padStart(8, '⠀')}
                  </div>
                </td>
              );
            })}
          </tr>
          <tr>
            <td>
              <div>
                {T('평균 심박수 (bpm)')}
              </div>
            </td>
            {viewMode === 'ReportExerciseSteps' && stepList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {(!data.avg_heart_rate ? '-' : numberWithComma(data.avg_heart_rate)).padStart(8, '⠀')}
                  </div>
                </td>
              );
            })}
            {viewMode === 'ReportExerciseCalories' && caloryList.map((data, index) => {
              return (
                <td key={index}>
                  <div>
                    {(!data.avg_heart_rate ? '-' : numberWithComma(data.avg_heart_rate)).padStart(8, '⠀')}
                  </div>
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </Section>
  );
}
